import { ClipboardList } from "lucide-react";
import { resumoDaFace } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";
import { AcaoDoRodape, Card, CardEmpty, CardLoading, Rodape, VerTodos } from "./QuadroBase";
import type { QuadroProps } from "./tipos";

/** Planos aprovados com o que falta fazer — o próximo procedimento de cada um em destaque. */
export function QuadroTratamentos({ patientId, menu, irParaAba, onNovo }: QuadroProps & { onNovo?: () => void }) {
  const query = trpc.plano.emAndamento.useQuery({ patientId });
  const planos = query.data ?? [];
  return (
    <Card icon={<ClipboardList className="h-4 w-4" />} title="Tratamentos em andamento" tone="emerald" menu={menu}>
      {query.isLoading ? (
        <CardLoading />
      ) : planos.length === 0 ? (
        <CardEmpty icon={<ClipboardList className="h-6 w-6" />} text="Nenhum tratamento em andamento" hint="Planos aprovados aparecem aqui" />
      ) : (
        <ul className="space-y-2.5">
          {planos.slice(0, 3).map((p) => {
            const feitos = p.itens.filter((i: { feitoEm: unknown }) => i.feitoEm).length;
            const proximo = p.itens.find((i: { feitoEm: unknown }) => !i.feitoEm);
            return (
              <li key={p.id}>
                <button type="button" onClick={() => irParaAba("tratamentos")} className="w-full rounded-lg px-2 py-1.5 text-left hover:bg-zinc-50 dark:hover:bg-muted/40">
                  <div className="flex items-center justify-between gap-2 text-[11px] font-medium text-zinc-500 dark:text-muted-foreground">
                    <span className="truncate">Plano nº {p.numero}{p.titulo ? ` · ${p.titulo}` : ""}</span>
                    <span className="shrink-0">{feitos}/{p.itens.length}</span>
                  </div>
                  <div className="mt-1 h-1.5 overflow-hidden rounded-full bg-zinc-100 dark:bg-muted">
                    <div className="h-full bg-emerald-500" style={{ width: `${(feitos / Math.max(p.itens.length, 1)) * 100}%` }} />
                  </div>
                  {proximo && (
                    <p className="mt-1 truncate text-sm font-medium text-zinc-900 dark:text-foreground">
                      Próximo: {proximo.nome}
                      {proximo.dentes || proximo.marcacoes.length ? ` (${[proximo.dentes, resumoDaFace(proximo.marcacoes, proximo.unidade)].filter(Boolean).join(" · ")})` : ""}
                    </p>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      )}
      <Rodape>
        <VerTodos rotulo="Ver planos" onClick={() => irParaAba("tratamentos")} />
        {onNovo ? <AcaoDoRodape rotulo="Novo plano" onClick={onNovo} /> : <span />}
      </Rodape>
    </Card>
  );
}
